import styled from 'styled-components'

export const TypeBoldHeadingLevel1 = styled.h1`
  font-weight: 700;
  font-size: 30px;
  color: #34495e;
  line-height: 36px;
`

export const TypeBoldHeadingLevel2 = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #34495e;
  line-height: 28px;
`

export const TypeBodyLevel1Center = styled.p`
  text-align: center;
`

export const TypeBodyLevel2Left = styled.p``

export const TypeBoldItalic = styled.p`
  font-family: Lato-BoldItalic;
  font-size: 24px;
  color: #364553;
`

export const Copyright = styled.p`
  font-size: 16px;
  text-align: center;
`
